const LegendPill = ({ color = "#d4d4d5" }) => (
  <span
    style={{
      display: "inline-block",
      width: 18,
      height: 8,
      borderRadius: 999,
      border: `2px solid ${color}`,
      marginRight: 8,
      verticalAlign: "middle",
    }}
  />
);

export default LegendPill;
